<template>
  <el-dialog
    title="设置"
    :visible.sync="dialogVisible"
    width="520px"
    append-to-body
    :close-on-click-modal="false"
    custom-class="speed-curve-settings-dialog"
    @open="loadDraft"
    @closed="$emit('closed')"
  >
    <section class="scs-section">
      <h4 class="scs-section__title">超速配置</h4>
      <div class="scs-overspeed">
        <span class="scs-overspeed__label">超速阈值 (km/h)</span>
        <el-input-number
          v-model="draft.overspeedLimit"
          :min="1"
          :max="300"
          :step="1"
          controls-position="right"
        />
      </div>
      <p class="scs-tip">速度曲线将在该速度处显示红色临界线</p>
    </section>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  DEFAULT_SPEED_CURVE_SETTINGS,
  getSpeedCurveSettings,
  saveSpeedCurveSettings
} from '@/utils/speedCurveSettings'

export default {
  name: 'SpeedCurveSettingsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      draft: {
        overspeedLimit: DEFAULT_SPEED_CURVE_SETTINGS.overspeedLimit
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    loadDraft() {
      const current = getSpeedCurveSettings()
      this.draft = {
        overspeedLimit: current.overspeedLimit
      }
    },
    confirm() {
      saveSpeedCurveSettings({
        ...getSpeedCurveSettings(),
        overspeedLimit: this.draft.overspeedLimit
      })
      this.dialogVisible = false
      this.$emit('saved')
    }
  }
}
</script>

<style scoped>
.scs-section + .scs-section {
  margin-top: 1.25rem;
}

.scs-section__title {
  margin: 0 0 0.75rem;
  padding-left: 0.5rem;
  border-left: 0.1875rem solid var(--layout-primary, #087dff);
  font-size: 0.875rem;
  font-weight: 600;
  color: #303133;
  line-height: 1.2;
}

.scs-tip {
  margin: 0.5rem 0 0;
  font-size: 0.75rem;
  color: #909399;
}

.scs-overspeed {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.scs-overspeed__label {
  font-size: 0.875rem;
  color: #606266;
}
</style>
